import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const selectClientTournamentSlice = createSelector(
  (state: RootState) => state.clientChampionship,
  (state) => state,
);

export const selectTeams = createSelector([selectClientTournamentSlice], (state) => state.teams);
export const selectPlayers = createSelector([selectClientTournamentSlice], (state) => state.players);
export const selectStages = createSelector([selectClientTournamentSlice], (state) => state.stages);
export const selectMatches = createSelector([selectClientTournamentSlice], (state) => state.matches);
export const selectChampionship = createSelector([selectClientTournamentSlice], (state) => state.championship);

export const selectStatus = createSelector([selectClientTournamentSlice], (state) => ({
  loaded: state.loaded,
  loading: state.loading,
  error: state.error,
}));
